// extracted by mini-css-extract-plugin
export var displayNone = "_pj-6";
export var imgContainer = "_pj-2";
export var overflowHidden = "_pj-3";
export var productInfoCardButtonContainer = "_pj-5";
export var productTitleText = "_pj-4";
export var rightArrow = "_pj-1";
export var rightArrowContainer = "_pj-0";